// lib/crypto.ts - CLIENT SIDE (FIXED)
export async function encrypt(text: string) {
  const enc = new TextEncoder();
  const SECRET = process.env.NEXT_PUBLIC_SECRET_KEY || 'fallback-key-change-me';
  
  // Hash the secret to get exactly 32 bytes for AES-256
  const keyMaterial = await crypto.subtle.digest(
    'SHA-256',
    enc.encode(SECRET)
  );
  
  const key = await crypto.subtle.importKey(
    "raw",
    keyMaterial,
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));
  
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    enc.encode(text)
  );

  // ✅ Split the encrypted data from the auth tag
  const encryptedArray = new Uint8Array(encrypted);
  const ciphertext = encryptedArray.slice(0, -16); // All but last 16 bytes
  const authTag = encryptedArray.slice(-16);        // Last 16 bytes

  return {
    data: btoa(String.fromCharCode(...ciphertext)),
    iv: btoa(String.fromCharCode(...iv)),
    authTag: btoa(String.fromCharCode(...authTag)), // ✅ Add authTag
  };
}